<template lang="pug">
  nav.navbar.navbar-expand-md.navbar-dark.fixed-top.bg-dark.green
    router-link.navbar-brand(to='home') Hawaii CAN
    button.navbar-toggler(type="button", data-toggle="collapse", data-target="#navbarsExampleDefault", aria-controls="navbarsExampleDefault", aria-expanded="false", aria-label="Toggle navigation")
      span.navbar-toggler-icon

    .collapse.navbar-collapse#navbarsExampleDefault
      ul.navbar-nav.ml-auto
        //- li.nav-item
        //-   router-link.nav-link(to='/home') Home
        //- li.nav-item
        //-   router-link.nav-link(to='/news') News

        li.nav-item
          router-link.nav-link(to='/about/us') About Us

        li.nav-item
          router-link.nav-link(to='/programs') Programs

        li.nav-item
          router-link.nav-link(to='/about/faq') FAQ

        li.nav-item
          router-link.nav-link(to='/contact') Contact Us


        //- li.nav-item.dropdown(:class="{ 'active': isTraineeActive }")
        //-   a.nav-link.dropdown-toggle#traineeDropdown(href="#", data-toggle="dropdown", aria-haspopup="true", aria-expanded="false") Meet Our Trainees
        //-   .dropdown-menu(aria-labelledby="traineeDropdown")
        //-     router-link.dropdown-item(to="/trainees/hannahsblog") Hannah's Blog
        //-     router-link.dropdown-item(to="/trainees/trainees") Trainees
        //-     router-link.dropdown-item(to='/trainees/puppies') Puppies
        //-     router-link.dropdown-item(to='/trainees/graduates') Graduates
        //- li.nav-item
        //-   router-link.nav-link(to='/how-you-can-help') How You Can Help


        //- li.nav-item.dropdown(:class="{ 'active': isAboutActive }")
        //-   a.nav-link.dropdown-toggle#aboutDropdown(href="#", data-toggle="dropdown", aria-haspopup="true", aria-expanded="false") About
        //-   .dropdown-menu.dropdown-menu-right(aria-labelledby="aboutDropdown")
        //-     router-link.dropdown-item(to="/about/us") About Us
        //-     router-link.dropdown-item(to='/about/faq') FAQ


      //- form.form-inline.my-2.my-lg-0
      //-   input.form-control.mr-sm-2(type="text", placeholder="Search", aria-label="Search")
      //-   button.btn.btn-outline-success.my-2.my-sm-0(type="submit") Search
</template>

<script>

export default {
  name: 'NavBar',
  computed: {
    isTraineeActive: function () {
      const currentPath = this.$route.path || '';
      return currentPath.indexOf('/trainee') === 0;
    },
    isAboutActive: function () {
      const currentPath = this.$route.path || '';
      return currentPath.indexOf('/about') === 0;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .green {
    background-color: #00743F !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue